// Design Tokens - Aligned with theme.js
// Use these for consistency across components

export const tokens = {
  colors: {
    // Backgrounds
    surface: '#ffffff',
    surfaceSubtle: '#F8FAFC',
    surfaceElevated: '#ffffff',
    background: '#FAFBFC',

    // Borders
    border: '#E2E8F0',
    borderLight: '#F1F5F9',
    borderHover: '#CBD5E1',

    // Text
    textPrimary: '#0F172A',
    textSecondary: '#475569',
    textMuted: '#64748B',
    textDisabled: '#94A3B8',

    // Brand
    primary: '#2563EB',
    primaryLight: '#3B82F6',
    primaryDark: '#1D4ED8',

    // Semantic
    success: '#10B981',
    successLight: '#D1FAE5',
    successDark: '#059669',
    warning: '#F59E0B',
    warningLight: '#FEF3C7',
    warningDark: '#D97706',
    error: '#EF4444',
    errorLight: '#FEE2E2',
    errorDark: '#DC2626',
    info: '#06B6D4',
    infoLight: '#CFFAFE',
    infoDark: '#0891B2',

    // Table specific
    headerBg: '#F8FAFC',
    cellBorder: '#F1F5F9',
    rowHover: '#F8FAFC',

    // Shadows
    shadow: '0 1px 3px 0 rgba(0, 0, 0, 0.04), 0 2px 6px 0 rgba(0, 0, 0, 0.06)',
    shadowHover: '0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 4px 12px 0 rgba(0, 0, 0, 0.08)',
    shadowDropdown: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 8px 16px -2px rgba(0, 0, 0, 0.1)',
  },

  radius: {
    xs: 4,
    sm: 6,
    md: 8,
    lg: 10,
    xl: 12,
    '2xl': 16,
    full: 9999,
  },

  spacing: {
    cardMargin: '0',
    cardPadding: '20px',
    sectionGap: '24px',
    pageGutter: '24px',
  },

  sizes: {
    tableHeight: 520,
    smallTableHeight: 200,
    mediumTableHeight: 400,
    sidebarWidth: 260,
    topbarHeight: 56,
  },

  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    monoFamily: '"SF Mono", "Fira Code", "Fira Mono", Menlo, Monaco, Consolas, monospace',
  },

  transitions: {
    fast: '0.15s ease',
    normal: '0.2s ease',
    slow: '0.3s ease',
    spring: '0.2s cubic-bezier(0.16, 1, 0.3, 1)',
  },
};

export default tokens;
